export function htmlify(val:string = ""):string {
    if (!val) {
        return ""
    }

    const regexEnter = new RegExp(/(\r\n|\n|\r)/gm);
    const valNormalized = val.replace(regexEnter, "<br>").trim();
    
    return `<p>${valNormalized}</p>`
}
